const RegistrationInfoConfirm = ({
    fields,gender,
    birthEra,
    destination,
    viewMode,
    member
                                }) => {

  return (
    <>
              <h2>登録情報</h2>
              <dl>
                <dt>氏名<span class="red">*</span></dt>
                  <dd> {  viewMode ? member.familyName : fields.familyName } { viewMode ? member.givenName : fields.givenName } </dd>
                <dt>氏名（フリガナ)<span class="red">*</span></dt>
                  <dd> { viewMode ? member.familyNameKana : fields.familyNameKana } { viewMode ? member.givenNameKana : fields.givenNameKana } </dd>
                <dt>性別<span class="red">*</span></dt>
          <dd> { 1 == gender ? '男' : '女' }</dd>
                <dt>生年月日<span class="red">*</span></dt>
          <dd> {viewMode ? member.birthDate : fields.birthDate} </dd>
                <dt>送付先<span class="red">*</span></dt>
          <dd> { 1 == destination ? '現住所' : '所属先' }</dd>
                </dl>
    </>
  );
}

export default RegistrationInfoConfirm;
